import styled from 'styled-components';

export const Container = styled.div`
  margin: 16px 0px;
  display: grid;
  grid-template-columns: repeat(4, 94px);
  grid-column-gap: 2px;
`;
